import { render, staticRenderFns } from "./GSignin.vue?vue&type=template&id=a0ebff1e&scoped=true&"
import script from "./GSignin.vue?vue&type=script&lang=ts&"
export * from "./GSignin.vue?vue&type=script&lang=ts&"
import style0 from "./GSignin.vue?vue&type=style&index=0&id=a0ebff1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ebff1e",
  null
  
)

export default component.exports